export async function polyfill():Promise<void> {
    if (!('scrollBehavior' in document.documentElement.style)) {
        await import('scroll-behavior-polyfill')
    }
} 